// Frontend mirror of backend/pipeline.py — keep in sync with SUB_STATUSES there.
import {
  Sparkles, FileText, Wrench, Archive, ClipboardCheck, Calendar, Store, Droplets,
  ScissorsSquareDashedBottom, PaintRoller, Cog, Sparkle, PackageCheck, PackageOpen,
  Send, XCircle, Check, HelpCircle, Palette, Pencil, ThumbsUp, Brush, ShieldCheck,
  PhoneCall,
} from "lucide-react";

export const MAIN_STATUSES = [
  { value: "lead",     label: "Lead",     icon: Sparkles,   colour: "info" },
  { value: "quote",    label: "Quote",    icon: FileText,   colour: "warning" },
  { value: "job",      label: "Job",      icon: Wrench,     colour: "success" },
  { value: "archived", label: "Archived", icon: Archive,    colour: "muted" },
];

export const SUB_STATUSES = {
  lead: [
    { value: "new",         label: "New",         icon: Sparkles },
    { value: "contacted",   label: "Contacted",   icon: Send },
    { value: "qualified",   label: "Qualified",   icon: Check },
    { value: "lost",        label: "Lost",        icon: XCircle },
  ],
  quote: [
    { value: "unquoted",    label: "Unquoted",    icon: HelpCircle },
    { value: "draft",       label: "Draft",       icon: FileText },
    { value: "sent",        label: "Sent",        icon: Send },
    { value: "follow_up",   label: "Follow-up call", icon: PhoneCall },
    { value: "accepted",    label: "Accepted",    icon: Check },
    { value: "rejected",    label: "Rejected",    icon: XCircle },
  ],
  job: [
    { value: "unbooked",                label: "Unbooked",            icon: HelpCircle },
    { value: "booked",                  label: "Booked",              icon: Calendar },
    { value: "awaiting_design",         label: "Awaiting design",     icon: Palette },
    { value: "design_in_progress",      label: "Design in progress",  icon: Pencil },
    { value: "design_approved",         label: "Design approved",     icon: ThumbsUp },
    { value: "in_store",                label: "In store",            icon: Store },
    { value: "wash_down",               label: "Wash down",           icon: Droplets },
    // Physical order: disassemble panels first, THEN clay bar the bare
    // surfaces (better grip on non-trim-covered areas) before wrapping.
    { value: "disassembly",             label: "Disassembly",         icon: ScissorsSquareDashedBottom },
    { value: "clay_bar",                label: "Clay bar",            icon: Brush },
    { value: "wrapping",                label: "Wrapping",            icon: PaintRoller },
    { value: "assembly",                label: "Assembly",            icon: Cog },
    { value: "quality_check",           label: "Quality check",       icon: ShieldCheck },
    { value: "ready_for_collection",    label: "Ready to collect",    icon: PackageCheck },
    { value: "collected",               label: "Collected",           icon: PackageOpen },
  ],
  archived: [
    { value: "completed", label: "Completed", icon: Check },
    { value: "cancelled", label: "Cancelled", icon: XCircle },
    { value: "lost",      label: "Lost",      icon: XCircle },
  ],
};

export const subMeta = (main, sub) =>
  (SUB_STATUSES[main] || []).find((s) => s.value === sub) || { value: sub, label: sub, icon: HelpCircle };

export const mainMeta = (main) =>
  MAIN_STATUSES.find((m) => m.value === main) || MAIN_STATUSES[2];

/** Return the next sub-status in the job pipeline, or null if already at end. */
export const nextJobSub = (current) => {
  const list = SUB_STATUSES.job.map((s) => s.value);
  const idx = list.indexOf(current);
  return idx === -1 || idx === list.length - 1 ? null : list[idx + 1];
};
